import { render, staticRenderFns } from "./BetOptions.vue?vue&type=template&id=887b4470&scoped=true&"
import script from "./BetOptions.vue?vue&type=script&lang=js&"
export * from "./BetOptions.vue?vue&type=script&lang=js&"
import style0 from "./BetOptions.vue?vue&type=style&index=0&id=887b4470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887b4470",
  null
  
)

export default component.exports